<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import Vue from 'vue'
import plugins from './plugins'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'App',
  created () {
    let user = JSON.parse(localStorage.getItem('user'))
    this.setUserLogued(user)

    let user_b2b = JSON.parse(localStorage.getItem('user_b2b'))
    this.setUserLoguedB2b(user_b2b)

    let permissions = JSON.parse(localStorage.getItem('permissions'))
    this.setPermissions(permissions)

    let subscriber = JSON.parse(localStorage.getItem('subscriber'))
    this.setSubscriber(subscriber)

    if (user && user.type === 'c'){
      this.$router.push('/b2b/inicio')
    }
  },
  methods: {
    ...mapMutations('login', [
      'setUserLogued',
      'setUserLoguedB2b',
      'setPermissions',
      'setSubscriber'
    ])
  },
  computed: {
    ...mapState('login', ['user_b2b'])
  }
};
</script>

<style src="./assets/css/form_layouts.css"></style>
<style lang="sass" src="./assets/sass/buttons/buttons.scss"></style>
<style src="awesome-bootstrap-checkbox/awesome-bootstrap-checkbox.css"></style>
<style lang="scss" src="./assets/sass/bootstrap/bootstrap.scss"></style>
<style src="font-awesome/css/font-awesome.min.css"></style>
<style src="themify-icons/css/themify-icons.css"></style>
<style src="./assets/css/style.css"></style>

<style>
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-dark.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham-dark.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-material.css";
</style>



// WEBPACK FOOTER //
// src/App.vue